import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import Icon from '../components/Icon/Icon.js';

var IconCardContactless = function IconCardContactless(_ref) {
  var title = _ref.title,
      filled = _ref.filled,
      otherProps = _objectWithoutProperties(_ref, ["title", "filled"]);

  return /*#__PURE__*/React.createElement(Icon, otherProps, filled ? /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 6a3 3 0 013 3v30a3 3 0 01-3 3H3a3 3 0 01-3-3V9a3 3 0 013-3h42zM15 25H8a2 2 0 00-1.995 1.851L6 27v3a2 2 0 001.851 1.995L8 32h7a2 2 0 001.995-1.851L17 30v-3a2 2 0 00-1.851-1.995L15 25zm21.226-12.473a1.62 1.62 0 00.118 2.243c1.605 1.484 2.572 3.762 2.572 6.245 0 2.468-.955 4.735-2.545 6.22a1.622 1.622 0 00-.106 2.243 1.51 1.51 0 002.178.109C40.684 27.495 42 24.37 42 21.016c0-3.376-1.333-6.517-3.596-8.61a1.51 1.51 0 00-2.178.121zm-4.8 2.754a1.39 1.39 0 000 2.003 5.15 5.15 0 010 7.425 1.39 1.39 0 000 2.003c.57.553 1.49.553 2.06 0a7.93 7.93 0 000-11.432 1.486 1.486 0 00-2.06 0z"
  })) : /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 6a3 3 0 013 3v30a3 3 0 01-3 3H3a3 3 0 01-3-3V9a3 3 0 013-3h42zm0 3H3v30h42V9zM15 24a3 3 0 013 3v3a3 3 0 01-3 3H9a3 3 0 01-3-3v-3a3 3 0 013-3h6zm0 3H9v3h6v-3zm23.404-14.594C40.667 14.5 42 17.64 42 21.016c0 3.356-1.316 6.48-3.557 8.572a1.51 1.51 0 01-2.178-.109 1.621 1.621 0 01.106-2.243c1.6-1.485 2.545-3.752 2.545-6.22 0-2.483-.967-4.76-2.572-6.245a1.622 1.622 0 01-.118-2.243 1.51 1.51 0 012.178-.121zm-4.917 2.875a7.93 7.93 0 010 11.432c-.57.553-1.49.553-2.06 0a1.39 1.39 0 010-2.003 5.15 5.15 0 000-7.425 1.39 1.39 0 010-2.003 1.486 1.486 0 012.06 0z"
  })));
};

export default IconCardContactless;
